import {Table} from "antd";
import React, {useState, useEffect} from "react";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import {useHistory} from "react-router-dom";

const TransfersTable = () => {
    const stores = useStore();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const [transfersDataLoading, transfersData, _, __, refetch] = useFetch({
        fetchFn: () =>
            stores.transferStore.getTransferReference({
                page: pagination.current,
                limit: pagination.pageSize
            }),
        loading: true,
        initialCall: false
    });

    useEffect(() => {
        refetch();
    }, [pagination.current, pagination.pageSize]);

    const transferReferences = transfersData?.transferReference?.data;

    const handleTableChange = newPagination => {
        setPagination({
            current: newPagination.current,
            pageSize: newPagination.pageSize,
            total: newPagination.total
        });
    };

    const continueRotation = async record => {
        try {
            setLoading(record._id);
            const continueRotationPage = await stores.transferStore.getTransferReference({
                id: record._id,
                status: record.status
            });

            if (continueRotationPage) {
                history.push(`/transfers/transfer-rotate?id=${record._id}&status=${record.status}`);
            }
        } catch (error) {
            console.error("Continue rotation error:", error);
        } finally {
            setLoading(false);
        }
    };

    const createRotation = async record => {
        try {
            setLoading(record._id);
            const continueRotationPage = await stores.transferStore.getTransferReference({
                id: record._id,
                status: record.status
            });

            if (continueRotationPage) {
                history.push(`/transfers/calculated-transfer?id=${record._id}&status=calculated`);
            }
        } catch (error) {
            console.error("Continue rotation error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Table
                dataSource={transferReferences}
                pagination={{
                    ...pagination,
                    total: transfersData?.transferReference?.pagination?.total || 0
                }}
                onChange={handleTableChange}
                scroll={{x: "100%"}}
                style={{width: "100vw"}}
                rowKey={record => record._id || record.key}
                loading={transfersDataLoading}
            >
                <Table.Column
                    title="Tarih"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt =>
                        createdAt ? moment(createdAt).format("DD/MM/YYYY HH:mm") : "-"
                    }
                />
                <Table.Column
                    title="Teslimat Sayısı"
                    dataIndex="shipmentCount"
                    key="shipmentCount"
                    render={shipmentCount => <span>{shipmentCount || 0} Teslimat</span>}
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="totalPackageCount"
                    key="totalPackageCount"
                    render={totalPackageCount => <span>{totalPackageCount || 0} Paket</span>}
                />

                <Table.Column
                    title="Durumu"
                    dataIndex="status"
                    key="status"
                    render={status => {
                        if (status === "created") return "Oluşturuldu";
                        if (status === "calculated") return "Hesaplandı";
                        return "-";
                    }}
                />
                <Table.Column
                    title="Aksiyon"
                    dataIndex="action"
                    key="action"
                    render={(_, record) => {
                        if (!record) return null;

                        if (record.status === "created") {
                            return (
                                <CustomButton
                                    onClick={() => continueRotation(record)}
                                    loading={loading === record._id}
                                >
                                    Rotalamaya Devam Et
                                </CustomButton>
                            );
                        } else if (record.status === "calculated") {
                            return (
                                <CustomButton
                                    onClick={() => createRotation(record)}
                                    loading={loading === record._id}
                                >
                                    Rotalama Oluştur
                                </CustomButton>
                            );
                        }
                        return null;
                    }}
                />
            </Table>
        </div>
    );
};

export default TransfersTable;
